import {
  EnrolmentStatus,
  EnrolmentStatusDetailsMap,
} from "@/constants/enrolment"
import {
  EnrolmentBrokerType,
  EnrolmentStatusType,
} from "@/models/operations/enrolment/enrolment.types"
import { EnrolmentSegment, EnrolmentSegmentType } from "@/types/Enrolment"
import {
  FilterCheckbox,
  FilterDateRange,
  FilterType,
  SoDataTableColumnType,
  SoDataTableHeader,
} from "@/types/components/SoDataTable"

interface EnrolmentTableHeader extends SoDataTableHeader {
  segments?: EnrolmentSegmentType[]
}

export const tableHeaders: EnrolmentTableHeader[] = [
  {
    title: "Submitted At",
    key: "createdAt",
    type: SoDataTableColumnType.DATE,
    sortKey: "created_at",
  },
  {
    title: "Email",
    key: "email",
    sortable: false,
  },
  {
    title: "Name",
    key: "customerName",
    sortable: false,
    segments: [EnrolmentSegment.ALL],
  },
  {
    title: "MPAN",
    key: "mpan",
    sortable: false,
  },
  {
    title: "MPRN",
    key: "mprn",
    sortable: false,
  },
  {
    title: "Postcode",
    key: "postcode",
    sortable: false,
    segments: [EnrolmentSegment.ALL],
  },
  {
    title: "Account Number",
    key: "accountPath",
    sortable: false,
    type: SoDataTableColumnType.LINK,
    segments: [EnrolmentSegment.ALL],
  },
  {
    title: "Reference",
    key: "thirdPartyReference",
    sortable: false,
  },
  {
    title: "Broker",
    key: "brokerLabel",
    sortKey: "broker",
    segments: [EnrolmentSegment.ALL],
  },
  {
    title: "Status",
    key: "mappedStatus",
    type: SoDataTableColumnType.STATUS,
    sortable: false,
    segments: [EnrolmentSegment.ALL],
  },
  {
    title: "Enrolment Failure Message",
    key: "enrolmentFailureMessage",
    sortKey: "enrolment_failure_message",
    segments: [
      EnrolmentSegment.JUNIFER_ERRORS,
      EnrolmentSegment.NON_JUNIFER_ERRORS,
    ],
  },
  {
    title: "Retry count",
    key: "retryCount",
    sortKey: "retry_count",
    segments: [EnrolmentSegment.JUNIFER_ERRORS],
  },
  {
    title: "Automated comms",
    key: "enrolmentAutomatedCommunication",
    sortKey: "enrolment_automated_comms",
    segments: [EnrolmentSegment.JUNIFER_ERRORS],
  },
]
export type TableFilters = {
  broker: FilterCheckbox<EnrolmentBrokerType>
  createdAt: FilterDateRange
  onboardingStatus: FilterCheckbox<EnrolmentStatusType>
}

export const tableFilters: TableFilters = {
  broker: {
    type: FilterType.CHECKBOX,
    label: "Broker",
    value: [],
    options: {},
    expandable: true,
  },
  onboardingStatus: {
    type: FilterType.CHECKBOX,
    label: "Enrolment Status",
    value: [],
    options: Object.entries(EnrolmentStatus).reduce(
      (options, [statusKey]) => ({
        ...options,
        [statusKey]: EnrolmentStatusDetailsMap[statusKey].short,
      }),
      {},
    ),
    expandable: true,
  },
  createdAt: {
    type: FilterType.DATE_RANGE,
    label: "Submitted At",
    value: { from: null, to: null },
    expandable: true,
  },
}
